import React from 'react'
import { usePermission } from '@fs/zion-permissions'
import { Route } from '@fs/zion-router'
import { useUser } from '@fs/zion-user'
import zionDebug from '@fs/zion-debug'
import AnonSessionGate, { redirectToLogin } from './AnonSessionGate'

// turn on in browser console with: localStorage.debug = 'fs:search:auth:*'
const debug = zionDebug('search:auth:affiliateAccessRoute')

export const AffiliateAccessWrapper = ({ children, LoadingSkeleton }) => {
  const { userLoading, signedIn } = useUser()
  const [inDiscoveryCenter, discoveryStatus] = usePermission('ThemisPrmDiscoveryCenter', 'CrxCtxPublicAccess')
  const [inAffiliateLibrary, libraryStatus] = usePermission('ThemisPrmAffiliate', 'CrxCtxPublicAccess')

  if (signedIn || inDiscoveryCenter || inAffiliateLibrary) {
    debug(
      'allowing route: signed in?',
      signedIn,
      'in discovery center?',
      inDiscoveryCenter,
      'in affiliate library?',
      inAffiliateLibrary
    )
    return children
  }

  if (userLoading || discoveryStatus === 'loading' || libraryStatus === 'loading') {
    debug(
      'loading: user loading?',
      userLoading,
      'discovery center loading?',
      discoveryStatus === 'loading',
      'affiliate library loading?',
      libraryStatus === 'loading'
    )
    return LoadingSkeleton || null
  }

  debug('requiring sign in.')
  redirectToLogin()
  return LoadingSkeleton || null
}

/**
 * Route wrapper that grants access to signed-in, discovery-center, and affiliate-library users
 * without the deprecated public-collection lookup. Used for catalog/DGS routes.
 */
const AffiliateAccessRoute = ({ component: Component, children, LoadingSkeleton, ...rest }) => (
  <AnonSessionGate LoadingSkeleton={LoadingSkeleton}>
    <Route {...rest}>
      {(props) => (
        <AffiliateAccessWrapper LoadingSkeleton={LoadingSkeleton}>
          {children || <Component {...props} />}
        </AffiliateAccessWrapper>
      )}
    </Route>
  </AnonSessionGate>
)

export default AffiliateAccessRoute
